// Otaku//Index brand lockup. Uses the dark-mode variant (white "OTAKU" text,
// keeps roundel + red "INDEX" intact) since every place the logo appears in
// this app has a black background. Aspect is ~2.54:1, so consumers set only
// the height (h-7, h-8, ...) and width auto-scales — nothing distorts.
export default function Logo({ className = "h-8", alt = "Otaku Index" }) {
  return (
    <img
      src="/brand/otaku-index-logo-dark.webp"
      alt={alt}
      draggable="false"
      loading="eager"
      decoding="async"
      className={`${className} w-auto object-contain select-none`}
    />
  );
}
